import { render } from "./LayoutSection.vue?vue&type=template&id=243bbec8"
import script from "./LayoutSection.vue?vue&type=script&lang=js"
export * from "./LayoutSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__